import React, { memo } from "react";

import { PopoverText } from '../../common/parts/PopoverText';
import { CourceRadio } from "../parts/CourceRadio";

export const FormCourceItem = memo((props) => {
  const { seiken_cources } = props;

  return (
    <>
      <p className="h3">生研コースの選択 
        <PopoverText textTitle="まずコースを選択してください" textBody="生研枠は企業ID１より取得しています。コースはご年齢やその他の条件によって選択できるコースを表示しています。表示さていないコースは選択できません。" />
      </p>
      <div className="list-group mb-4">
        {seiken_cources.map(item => 
          <CourceRadio key={item.id} item={item} />
        )}
      </div>
    </>
  );
});